import store from '../store'
import Login from 'src/components/Login/Login.vue'
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'

// Customer
import CustomerEdit from '../components/Customers/CustomerDetail.vue'
import CustomerSearch from '../components/Customers/Search.vue'
import CustomerCreate from '../components/Customers/Create.vue'
import Import from '../components/Customers/Import.vue'

//Partner
import PartnerEdit from '../components/Partner/Edit.vue'

// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'

import Home from '../components/Dashboard/Views/Dashboard/Home.vue'



function parseJwt (token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};


const ifNotAuthenticated = (to, from, next) => {
  if (!window.localStorage.getItem('jwt_token')) {
    next()
    return
  }
  next('/')
}

const ifAuthenticated = (to, from, next) => {
  if (window.localStorage.getItem('jwt_token')) {
    next()
    return
  }
  next('/login')
}
const isAdmin= (to, from, next) => {
  //decode the jwt to get the role
  const t= parseJwt(window.localStorage.getItem('jwt_token'))
  console.log('t = ',t['https://hasura.io/jwt/claims']['X-Hasura-Role']=="admin")
  if (t['https://hasura.io/jwt/claims']['X-Hasura-Role']=="admin") {
    next()
    return 

  }else{
    next('/login')
    return false
  }
  
}

let partnerMenu = {
  path: '/partner',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  beforeEnter: ifAuthenticated ,
  children: [ {
    path: 'edit/:id',
    name: 'Edit Partner',
    component: PartnerEdit
  },]
}
let customerMenu = {
  path: '/customer',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  beforeEnter: ifAuthenticated  ,
  children: [

    {
      path: 'edit/:id',
      name: 'Edit Customer',
      component: CustomerEdit
    },

    {
      path: ':property/:value',
      name: 'Find Customer',
      component: CustomerSearch,
      props: true
    },
    {
      path: 'create',
      name: 'Customer Create',
      component: CustomerCreate,
      props: true
    },
    {
      path: 'list',
      name: 'Customer List',
      component: CustomerSearch
    },
    ,
    {
      path: 'import',
      name: 'Customer Import',
      component: Import
    }

  ]
}







let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login,
  beforeEnter: ifNotAuthenticated
}



const routes = [
  {
    path: '/',
    name: 'home',
    component: DashboardLayout,
    redirect: '/home/',
    children: [

    ]
  },



  customerMenu,
partnerMenu,
 
  loginPage,
 
 
  {
    path: '/home',
    component: DashboardLayout,
    redirect: '/home/customers',
    beforeEnter: ifAuthenticated,
    children: [
     
      {
        path: 'customers',
        name: 'Customers',
        component: CustomerSearch
      },{
        path:'/',
        name: 'Home',
        component:Home
      }
    ]
  },
  {path: '*', component: NotFound}
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js